export const FlashSaleIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg width="121" height="58" viewBox="0 0 121 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0.988159 30.974V5.7832H17.809V9.62021H5.72804V16.4601H16.6529V20.2971H5.72804V31.0296H0.988159V30.974Z"
            fill="#F70000"
        />
        <path
            d="M52.3177 30.9739H47.231L56.4795 5.72754H62.3177L71.5662 30.9739H66.4795L59.4853 10.8992H59.3119L52.3177 30.9739ZM52.4911 21.1312H66.3061V24.8014H52.4911V21.1312Z"
            fill="#F70000"
        />
        <path
            d="M88.9072 12.6787C88.7916 11.6222 88.2714 10.788 87.4043 10.1763C86.5373 9.56465 85.3812 9.28661 83.9361 9.28661C82.9535 9.28661 82.0864 9.45343 81.3928 9.73148C80.6991 10.0095 80.1211 10.3988 79.7743 10.8993C79.3696 11.3997 79.1962 11.9558 79.1962 12.5675C79.1962 13.068 79.3118 13.5685 79.6008 13.9577C79.8321 14.347 80.1789 14.6807 80.6413 14.9587C81.1037 15.2367 81.5662 15.4592 82.0864 15.626C82.6066 15.7928 83.1269 15.9597 83.7049 16.0709L86.1904 16.6826C87.1731 16.905 88.1558 17.1831 89.0806 17.5723C90.0055 17.9616 90.8147 18.4065 91.5662 19.0181C92.3176 19.5742 92.8956 20.2972 93.3003 21.0757C93.7049 21.9098 93.9361 22.8552 93.9361 23.9117C93.9361 25.4132 93.5315 26.6922 92.78 27.8043C92.0286 28.9165 90.8725 29.8063 89.3696 30.418C87.8667 31.0297 86.0748 31.3633 83.9939 31.3633C81.9708 31.3633 80.1789 31.0853 78.676 30.4736C77.1731 29.8619 76.017 28.9721 75.15 27.8043C74.2829 26.6366 73.8783 25.1907 73.7627 23.5225H78.4448C78.5026 24.4122 78.7916 25.1351 79.3118 25.6912C79.8321 26.2473 80.4679 26.6922 81.2771 26.9702C82.0864 27.2483 82.9535 27.4151 83.9361 27.4151C84.9766 27.4151 85.9014 27.2483 86.6529 26.9702C87.4621 26.6922 88.0402 26.2473 88.5026 25.6912C88.965 25.1351 89.1962 24.5234 89.1962 23.8005C89.1962 23.1332 88.965 22.5771 88.6182 22.1879C88.2136 21.743 87.6933 21.4093 86.9997 21.0757C86.306 20.742 85.4968 20.5196 84.5141 20.2972L81.5084 19.5742C79.3696 19.0181 77.6355 18.2396 76.3639 17.1274C75.0922 16.0153 74.5141 14.5694 74.5141 12.79C74.5141 11.2885 74.9188 10.0095 75.7858 8.89734C76.6529 7.78517 77.7511 6.89543 79.254 6.28373C80.6991 5.67203 82.3754 5.33838 84.1673 5.33838C86.017 5.33838 87.6355 5.67203 89.0806 6.28373C90.4679 6.89543 91.5662 7.78517 92.3754 8.84173C93.1847 9.95391 93.5893 11.1773 93.5893 12.6231H88.9072V12.6787Z"
            fill="#F70000"
        />
        <path
            d="M98.098 30.974V5.7832H102.838V16.4601H114.977V5.7832H119.717V31.0296H114.977V20.2971H102.838V31.0296H98.098V30.974Z"
            fill="#F70000"
        />
        <path
            d="M0.352295 31.5856V5.17139H18.387V10.1762H6.36385V15.8483H17.2309V20.8531H6.36385V31.5856H0.352295Z"
            fill="url(#paint0_linear_644_1963)"
        />
        <path
            d="M66.0749 31.5856L63.9361 25.3574H54.9766L52.7801 31.5856H46.3639L56.0749 5.17139H62.7801L72.4911 31.6412H66.0749V31.5856ZM62.202 20.5194L59.4275 12.5674L56.6529 20.5194H62.202Z"
            fill="url(#paint1_linear_644_1963)"
        />
        <path
            d="M83.8783 31.975C81.7396 31.975 79.8899 31.6413 78.3292 31.0296C76.7107 30.3623 75.439 29.417 74.572 28.138C73.6471 26.859 73.1847 25.3575 73.0691 23.5781V22.9664H78.965L79.0228 23.5225C79.0807 24.301 79.3119 24.9127 79.7165 25.3575C80.1211 25.858 80.6991 26.2473 81.3928 26.4697C82.1442 26.7478 82.9535 26.859 83.8783 26.859C84.8032 26.859 85.6702 26.7478 86.3639 26.4697C87.0575 26.1917 87.5778 25.858 87.9246 25.4132C88.2714 24.9683 88.4448 24.4678 88.4448 23.9117C88.4448 23.4112 88.2714 23.022 87.9824 22.6883C87.6356 22.3547 87.1731 22.021 86.5373 21.743C85.8437 21.4649 85.0922 21.1869 84.1674 20.9644L81.1616 20.2415C78.9072 19.6854 77.1153 18.7957 75.7859 17.6835C74.3986 16.4601 73.7049 14.8475 73.7049 12.9012C73.7049 11.2885 74.1674 9.84268 75.0922 8.61929C76.0171 7.3959 77.2309 6.45055 78.7916 5.83885C80.2945 5.17154 82.0864 4.83789 83.9939 4.83789C85.9593 4.83789 87.6934 5.17154 89.1385 5.83885C90.6413 6.50616 91.8552 7.45151 92.7223 8.61929C93.5893 9.78708 94.0517 11.1773 94.0517 12.7343V13.346H88.2714L88.2136 12.79C88.098 11.9002 87.6934 11.1773 86.9419 10.6768C86.1905 10.1763 85.15 9.89829 83.8783 9.89829C82.9535 9.89829 82.202 10.0095 81.5662 10.2876C80.9882 10.51 80.5257 10.8436 80.1789 11.2329C79.8899 11.6222 79.7165 12.067 79.7165 12.5675C79.7165 12.9568 79.8321 13.2904 80.0055 13.6241C80.2367 13.9577 80.4679 14.1802 80.8148 14.4026C81.2194 14.625 81.624 14.8475 82.1442 15.0143C82.6645 15.1811 83.1847 15.348 83.7049 15.4592L86.1905 16.0709C87.1731 16.2933 88.2136 16.627 89.1385 17.0162C90.1211 17.4055 90.9882 17.906 91.7396 18.5177C92.5489 19.1294 93.1847 19.9079 93.6471 20.7976C94.1095 21.6874 94.3408 22.7439 94.3408 23.9117C94.3408 25.5244 93.9361 26.9146 93.0691 28.138C92.202 29.3614 90.9882 30.3067 89.4275 30.974C87.9824 31.6413 86.0749 31.975 83.8783 31.975Z"
            fill="url(#paint2_linear_644_1963)"
        />
        <path
            d="M114.341 31.5856V20.8531H103.474V31.5856H97.4622V5.17139H103.474V15.8483H114.341V5.17139H120.352V31.5856H114.341Z"
            fill="url(#paint3_linear_644_1963)"
        />
        <path
            d="M0.988159 30.974V5.7832H17.809V9.62021H5.72804V16.4601H16.6529V20.2971H5.72804V31.0296H0.988159V30.974Z"
            fill="url(#paint4_linear_644_1963)"
        />
        <path
            d="M52.3177 30.9739H47.231L56.4795 5.72754H62.3177L71.5662 30.9739H66.4795L59.4853 10.8992H59.3119L52.3177 30.9739ZM52.4911 21.1312H66.3061V24.8014H52.4911V21.1312Z"
            fill="url(#paint5_linear_644_1963)"
        />
        <path
            d="M88.9072 12.6787C88.7916 11.6222 88.2714 10.788 87.4043 10.1763C86.5373 9.56465 85.3812 9.28661 83.9361 9.28661C82.9535 9.28661 82.0864 9.45343 81.3928 9.73148C80.6991 10.0095 80.1211 10.3988 79.7743 10.8993C79.3696 11.3997 79.1962 11.9558 79.1962 12.5675C79.1962 13.068 79.3118 13.5685 79.6008 13.9577C79.8321 14.347 80.1789 14.6807 80.6413 14.9587C81.1037 15.2367 81.5662 15.4592 82.0864 15.626C82.6066 15.7928 83.1269 15.9597 83.7049 16.0709L86.1904 16.6826C87.1731 16.905 88.1558 17.1831 89.0806 17.5723C90.0055 17.9616 90.8147 18.4065 91.5662 19.0181C92.3176 19.5742 92.8956 20.2972 93.3003 21.0757C93.7049 21.9098 93.9361 22.8552 93.9361 23.9117C93.9361 25.4132 93.5315 26.6922 92.78 27.8043C92.0286 28.9165 90.8725 29.8063 89.3696 30.418C87.8667 31.0297 86.0748 31.3633 83.9939 31.3633C81.9708 31.3633 80.1789 31.0853 78.676 30.4736C77.1731 29.8619 76.017 28.9721 75.15 27.8043C74.2829 26.6366 73.8783 25.1907 73.7627 23.5225H78.4448C78.5026 24.4122 78.7916 25.1351 79.3118 25.6912C79.8321 26.2473 80.4679 26.6922 81.2771 26.9702C82.0864 27.2483 82.9535 27.4151 83.9361 27.4151C84.9766 27.4151 85.9014 27.2483 86.6529 26.9702C87.4621 26.6922 88.0402 26.2473 88.5026 25.6912C88.965 25.1351 89.1962 24.5234 89.1962 23.8005C89.1962 23.1332 88.965 22.5771 88.6182 22.1879C88.2136 21.743 87.6933 21.4093 86.9997 21.0757C86.306 20.742 85.4968 20.5196 84.5141 20.2972L81.5084 19.5742C79.3696 19.0181 77.6355 18.2396 76.3639 17.1274C75.0922 16.0153 74.5141 14.5694 74.5141 12.79C74.5141 11.2885 74.9188 10.0095 75.7858 8.89734C76.6529 7.78517 77.7511 6.89543 79.254 6.28373C80.6991 5.67203 82.3754 5.33838 84.1673 5.33838C86.017 5.33838 87.6355 5.67203 89.0806 6.28373C90.4679 6.89543 91.5662 7.78517 92.3754 8.84173C93.1847 9.95391 93.5893 11.1773 93.5893 12.6231H88.9072V12.6787Z"
            fill="url(#paint6_linear_644_1963)"
        />
        <path
            d="M98.098 30.974V5.7832H102.838V16.4601H114.977V5.7832H119.717V31.0296H114.977V20.2971H102.838V31.0296H98.098V30.974Z"
            fill="url(#paint7_linear_644_1963)"
        />
        <path
            d="M0.988159 30.9741V6.33936H17.1731V9.62028H5.09221V17.0719H16.0171V20.2972H5.09221V30.9741H0.988159Z"
            fill="url(#paint8_linear_644_1963)"
        />
        <path
            d="M66.4216 30.9741L64.2251 24.7459H53.9361L51.7974 30.9741H47.4043L56.4216 6.33936H61.8552L70.8725 30.9741H66.4216ZM55.0344 21.6874H63.1846L59.4274 10.8993H58.7916L55.0344 21.6874Z"
            fill="url(#paint9_linear_644_1963)"
        />
        <path
            d="M83.5893 31.3635C81.624 31.3635 79.8321 31.0855 78.387 30.4738C76.9419 29.9177 75.8436 29.028 75.0344 27.9158C74.2829 26.8592 73.8783 25.5802 73.7627 24.1344H77.8089C77.9245 24.9685 78.2136 25.6358 78.676 26.1919C79.1962 26.8036 79.8899 27.3041 80.7569 27.5821C81.5662 27.8602 82.5488 28.027 83.5315 28.027C84.5719 28.027 85.5546 27.8602 86.3639 27.5821C87.1731 27.2485 87.8667 26.8036 88.3292 26.2475C88.7916 25.6358 89.0806 24.9685 89.0806 24.19C89.0806 23.4671 88.8494 22.8554 88.387 22.3549C87.9824 21.91 87.3465 21.5208 86.6529 21.1871C85.9592 20.9091 85.0922 20.631 84.1673 20.4086L81.1615 19.6857C79.0806 19.1852 77.4043 18.3511 76.1904 17.2945C75.0344 16.2935 74.3985 14.9033 74.3985 13.1795C74.3985 11.7892 74.8032 10.5102 75.6124 9.45366C76.4217 8.39709 77.5199 7.56296 78.9072 6.95126C80.2945 6.33957 81.913 6.06152 83.7049 6.06152C85.4968 6.06152 87.1153 6.33957 88.5026 6.95126C89.8321 7.56296 90.9303 8.39709 91.6818 9.45366C92.3754 10.399 92.78 11.5112 92.8378 12.7346H88.8494C88.676 11.678 88.1558 10.8995 87.2309 10.2878C86.3061 9.6761 85.0922 9.34244 83.5893 9.34244C82.5488 9.34244 81.6818 9.50927 80.9303 9.78732C80.1789 10.121 79.6008 10.5102 79.1962 11.0663C78.7916 11.6224 78.5604 12.2341 78.5604 12.9014C78.5604 13.5131 78.676 14.0136 78.965 14.4585C79.254 14.9033 79.6008 15.237 80.1211 15.515C80.5835 15.7931 81.1037 16.0155 81.624 16.2379C82.1442 16.4048 82.7222 16.5716 83.2425 16.6828L85.6702 17.2945C86.6529 17.5169 87.5777 17.795 88.5026 18.1842C89.3696 18.5735 90.1789 19.0184 90.8725 19.5745C91.5662 20.1306 92.1442 20.7979 92.5488 21.5764C92.9534 22.3549 93.1847 23.2447 93.1847 24.3012C93.1847 25.6914 92.78 26.9704 92.0864 28.027C91.3349 29.0836 90.2367 29.9177 88.7916 30.5294C87.4043 31.0855 85.6124 31.3635 83.5893 31.3635Z"
            fill="url(#paint10_linear_644_1963)"
        />
        <path
            d="M114.977 30.9741V20.2972H102.202V30.9741H98.098V6.33936H102.202V17.0719H114.977V6.33936H119.138V30.9741H114.977Z"
            fill="url(#paint11_linear_644_1963)"
        />
        <path
            d="M60.6994 40.483C60.6416 39.7601 60.2947 39.204 59.7167 38.8147C59.1387 38.4255 58.3294 38.203 57.4046 38.203C56.7687 38.203 56.1907 38.3142 55.6705 38.4811C55.208 38.6479 54.8034 38.9259 54.5722 39.2596C54.341 39.5932 54.1676 39.9825 54.1676 40.3718C54.1676 40.7054 54.2254 41.0391 54.3988 41.3171C54.5722 41.5952 54.8034 41.8176 55.0924 41.9844C55.3814 42.1513 55.7283 42.3181 56.0751 42.4293C56.4219 42.5405 56.7687 42.6517 57.1733 42.7073L58.8496 43.0966C59.4855 43.2634 60.1791 43.4303 60.7572 43.7083C61.393 43.9863 61.9132 44.2644 62.4335 44.6537C62.8959 45.0429 63.3005 45.4878 63.5895 46.0439C63.8785 46.6 63.9942 47.2117 63.9942 47.9346C63.9942 48.9355 63.7051 49.8253 63.1849 50.5482C62.6647 51.3267 61.9132 51.8828 60.9306 52.3277C59.9479 52.7725 58.734 52.9394 57.3468 52.9394C55.9595 52.9394 54.8034 52.7169 53.7629 52.3277C52.7225 51.9384 51.971 51.3267 51.393 50.5482C50.815 49.7697 50.5259 48.8243 50.4681 47.7121H53.5895C53.6473 48.3238 53.8207 48.7687 54.1676 49.158C54.5144 49.5472 54.919 49.8253 55.497 50.0477C56.0173 50.2145 56.6531 50.3257 57.2889 50.3257C57.9826 50.3257 58.6184 50.2145 59.1387 50.0477C59.6589 49.8253 60.0635 49.5472 60.3525 49.2136C60.6416 48.8799 60.815 48.435 60.815 47.9346C60.815 47.4897 60.6994 47.156 60.4103 46.8224C60.1213 46.5443 59.7745 46.2663 59.3121 46.0995C58.8496 45.877 58.2716 45.7102 57.6358 45.599L55.6126 45.0985C54.1676 44.7649 53.0115 44.2088 52.2022 43.4859C51.3352 42.7629 50.9306 41.762 50.9306 40.5942C50.9306 39.5932 51.2196 38.7035 51.7976 37.9806C52.3757 37.2577 53.1271 36.646 54.1098 36.2567C55.0924 35.8675 56.1907 35.645 57.4046 35.645C58.6762 35.645 59.7745 35.8675 60.6994 36.2567C61.6242 36.646 62.3757 37.2577 62.8959 37.9806C63.4161 38.7035 63.7051 39.5376 63.7051 40.5386H60.6994V40.483Z"
            fill="#F70000"
        />
        <path
            d="M71.6818 52.7171H68.2714L74.4563 35.812H78.387L84.5719 52.7171H81.1615L76.4795 39.2598H76.3638L71.6818 52.7171ZM71.7974 46.0996H81.1037V48.5464H71.7974V46.0996Z"
            fill="#F70000"
        />
        <path d="M89.832 52.7171V35.812H93.0112V50.1591H100.757V52.7171H89.832Z" fill="#F70000" />
        <path
            d="M106.479 52.7171V35.812H117.925V38.37H109.659V42.9856H117.347V45.5436H109.659V50.1591H117.982V52.7171H106.479Z"
            fill="#F70000"
        />
        <path
            d="M57.2887 53.3842C55.8436 53.3842 54.6297 53.1618 53.5892 52.7169C52.491 52.272 51.6817 51.6047 51.0459 50.7706C50.4101 49.9365 50.121 48.8799 50.0632 47.7121V47.2673H54.0517L54.1095 47.6565C54.1673 48.157 54.2829 48.5463 54.5719 48.8799C54.8609 49.2136 55.2077 49.4916 55.6702 49.6584C56.1326 49.8253 56.7106 49.9365 57.3465 49.9365C57.9823 49.9365 58.5603 49.8253 59.0228 49.6584C59.4852 49.4916 59.832 49.2692 60.0632 48.9355C60.2944 48.6575 60.4101 48.3238 60.4101 47.9346C60.4101 47.6009 60.2944 47.3229 60.121 47.1004C59.8898 46.878 59.6008 46.6556 59.1384 46.4887C58.6759 46.3219 58.1557 46.1551 57.5199 45.9882L55.4968 45.4878C53.9939 45.0985 52.78 44.5424 51.9129 43.7639C50.9881 42.9298 50.5257 41.8732 50.5257 40.5386C50.5257 39.482 50.8147 38.4811 51.4505 37.7025C52.0286 36.924 52.8956 36.2567 53.9361 35.8118C54.9765 35.367 56.1326 35.1445 57.4043 35.1445C58.7338 35.1445 59.8898 35.367 60.8725 35.8118C61.8551 36.2567 62.6644 36.8684 63.2424 37.6469C63.8205 38.4254 64.1095 39.3708 64.1673 40.4274V40.8166H60.2944L60.2366 40.483C60.1788 39.8713 59.8898 39.4264 59.4274 39.0928C58.9072 38.7591 58.2135 38.5367 57.3465 38.5367C56.7684 38.5367 56.2482 38.6479 55.7858 38.8147C55.3812 38.9815 55.0921 39.204 54.8609 39.482C54.6875 39.7601 54.5719 40.0381 54.5719 40.3718C54.5719 40.6498 54.6297 40.8722 54.7453 41.0947C54.8609 41.3171 55.0921 41.4839 55.3233 41.6508C55.6124 41.8176 55.9014 41.9288 56.1904 42.04C56.5372 42.1512 56.884 42.2625 57.2309 42.3181L58.9072 42.7073C59.6008 42.8742 60.2366 43.041 60.8725 43.319C61.5083 43.5971 62.0864 43.9307 62.6066 44.32C63.1268 44.7649 63.5892 45.2653 63.8783 45.8214C64.1673 46.4331 64.3407 47.1004 64.3407 47.9346C64.3407 48.9911 64.0517 49.9365 63.4736 50.7706C62.8956 51.6047 62.0864 52.2164 60.9881 52.6613C60.0632 53.1618 58.7916 53.3842 57.2887 53.3842Z"
            fill="url(#paint12_linear_644_1963)"
        />
        <path
            d="M80.9303 53.1064L79.4852 48.9357H73.4736L72.0286 53.1064H67.7511L74.2251 35.3672H78.7338L85.2078 53.1064H80.9303ZM78.3291 45.7104L76.4794 40.372L74.6297 45.7104H78.3291Z"
            fill="url(#paint13_linear_644_1963)"
        />
        <path
            d="M89.4274 53.106V35.4224H93.4736V49.7694H101.219V53.106H89.4274Z"
            fill="url(#paint14_linear_644_1963)"
        />
        <path
            d="M106.017 53.106V35.4224H118.329V38.7589H110.063V42.5403H117.751V45.9324H110.063V49.7694H118.387V53.106H106.017Z"
            fill="url(#paint15_linear_644_1963)"
        />
        <path
            d="M60.6994 40.483C60.6416 39.7601 60.2947 39.204 59.7167 38.8147C59.1387 38.4255 58.3294 38.203 57.4046 38.203C56.7687 38.203 56.1907 38.3142 55.6705 38.4811C55.208 38.6479 54.8034 38.9259 54.5722 39.2596C54.341 39.5932 54.1676 39.9825 54.1676 40.3718C54.1676 40.7054 54.2254 41.0391 54.3988 41.3171C54.5722 41.5952 54.8034 41.8176 55.0924 41.9844C55.3814 42.1513 55.7283 42.3181 56.0751 42.4293C56.4219 42.5405 56.7687 42.6517 57.1733 42.7073L58.8496 43.0966C59.4855 43.2634 60.1791 43.4303 60.7572 43.7083C61.393 43.9863 61.9132 44.2644 62.4335 44.6537C62.8959 45.0429 63.3005 45.4878 63.5895 46.0439C63.8785 46.6 63.9942 47.2117 63.9942 47.9346C63.9942 48.9355 63.7051 49.8253 63.1849 50.5482C62.6647 51.3267 61.9132 51.8828 60.9306 52.3277C59.9479 52.7725 58.734 52.9394 57.3468 52.9394C55.9595 52.9394 54.8034 52.7169 53.7629 52.3277C52.7225 51.9384 51.971 51.3267 51.393 50.5482C50.815 49.7697 50.5259 48.8243 50.4681 47.7121H53.5895C53.6473 48.3238 53.8207 48.7687 54.1676 49.158C54.5144 49.5472 54.919 49.8253 55.497 50.0477C56.0173 50.2145 56.6531 50.3257 57.2889 50.3257C57.9826 50.3257 58.6184 50.2145 59.1387 50.0477C59.6589 49.8253 60.0635 49.5472 60.3525 49.2136C60.6416 48.8799 60.815 48.435 60.815 47.9346C60.815 47.4897 60.6994 47.156 60.4103 46.8224C60.1213 46.5443 59.7745 46.2663 59.3121 46.0995C58.8496 45.877 58.2716 45.7102 57.6358 45.599L55.6126 45.0985C54.1676 44.7649 53.0115 44.2088 52.2022 43.4859C51.3352 42.7629 50.9306 41.762 50.9306 40.5942C50.9306 39.5932 51.2196 38.7035 51.7976 37.9806C52.3757 37.2577 53.1271 36.646 54.1098 36.2567C55.0924 35.8675 56.1907 35.645 57.4046 35.645C58.6762 35.645 59.7745 35.8675 60.6994 36.2567C61.6242 36.646 62.3757 37.2577 62.8959 37.9806C63.4161 38.7035 63.7051 39.5376 63.7051 40.5386H60.6994V40.483Z"
            fill="url(#paint16_linear_644_1963)"
        />
        <path
            d="M71.6818 52.7171H68.2714L74.4563 35.812H78.387L84.5719 52.7171H81.1615L76.4795 39.2598H76.3638L71.6818 52.7171ZM71.7974 46.0996H81.1037V48.5464H71.7974V46.0996Z"
            fill="url(#paint17_linear_644_1963)"
        />
        <path d="M89.832 52.7171V35.812H93.0112V50.1591H100.757V52.7171H89.832Z" fill="url(#paint18_linear_644_1963)" />
        <path
            d="M106.479 52.7171V35.812H117.925V38.37H109.659V42.9856H117.347V45.5436H109.659V50.1591H117.982V52.7171H106.479Z"
            fill="url(#paint19_linear_644_1963)"
        />
        <path
            d="M57.1152 52.9952C55.7857 52.9952 54.6297 52.7728 53.647 52.3835C52.6644 51.9942 51.9129 51.4381 51.3927 50.6596C50.8725 49.9367 50.5834 49.1026 50.5256 48.1016H53.2424C53.3002 48.6577 53.5314 49.1026 53.8204 49.4918C54.1673 49.9367 54.6297 50.2148 55.2077 50.4372C55.7857 50.6596 56.3638 50.7152 57.0574 50.7152C57.7511 50.7152 58.3869 50.604 58.9649 50.3816C59.543 50.1591 59.9476 49.8811 60.2944 49.4918C60.6412 49.1026 60.8146 48.6021 60.8146 48.1016C60.8146 47.6011 60.6412 47.2119 60.3522 46.8782C60.0632 46.5446 59.6586 46.3221 59.1962 46.0997C58.7337 45.8773 58.1557 45.7104 57.5199 45.5436L55.4967 45.0431C54.1094 44.7095 52.9534 44.1534 52.1441 43.4305C51.3349 42.7632 50.9303 41.8178 50.9303 40.65C50.9303 39.7047 51.2193 38.8706 51.7395 38.1476C52.2597 37.4247 53.0112 36.8686 53.936 36.4794C54.8609 36.0901 55.9592 35.8677 57.173 35.8677C58.3869 35.8677 59.4852 36.0901 60.3522 36.4794C61.2771 36.8686 61.9707 37.4247 62.4909 38.1476C62.9534 38.8149 63.2424 39.5379 63.3002 40.372H60.6412C60.5256 39.7047 60.1788 39.1486 59.543 38.7037C58.9071 38.2589 58.0979 38.0364 57.1152 38.0364C56.4216 38.0364 55.8435 38.1476 55.3233 38.3701C54.8031 38.5925 54.3985 38.8706 54.1672 39.2042C53.8782 39.5935 53.7626 39.9827 53.7626 40.4276C53.7626 40.8169 53.8782 41.1505 54.0516 41.4286C54.2251 41.7066 54.5141 41.929 54.8031 42.1515C55.0921 42.3183 55.4389 42.4851 55.8436 42.5963C56.1904 42.7076 56.595 42.8188 56.9418 42.93L58.6181 43.3193C59.254 43.4861 59.8898 43.6529 60.5256 43.931C61.1037 44.1534 61.6817 44.487 62.1441 44.8763C62.6066 45.2656 63.0112 45.7104 63.2424 46.2109C63.5314 46.7114 63.647 47.3231 63.647 48.046C63.647 48.9914 63.4158 49.8255 62.8956 50.5484C62.3753 51.2713 61.6817 51.8274 60.699 52.2167C59.6586 52.7728 58.4447 52.9952 57.1152 52.9952Z"
            fill="url(#paint20_linear_644_1963)"
        />
        <path
            d="M81.1615 52.717L79.7164 48.5463H72.78L71.3349 52.717H68.387L74.4563 36.2012H78.0979L84.1673 52.717H81.1615ZM73.5315 46.4888H79.0228L76.4794 39.2597H76.017L73.5315 46.4888Z"
            fill="url(#paint21_linear_644_1963)"
        />
        <path d="M89.832 52.717V36.2012H92.6066V50.5482H100.352V52.717H89.832Z" fill="url(#paint22_linear_644_1963)" />
        <path
            d="M106.479 52.717V36.2012H117.462V38.3699H109.196V43.3747H116.884V45.5435H109.196V50.5482H117.52V52.717H106.479Z"
            fill="url(#paint23_linear_644_1963)"
        />
        <path
            d="M6.59506 58C6.47945 58 6.42165 58 6.30604 57.9444C6.07483 57.7776 6.01703 57.4439 6.13263 57.2215L21.7396 32.6424H12.6644C12.491 32.6424 12.3176 32.5312 12.202 32.3643C12.0864 32.1975 12.0864 32.0307 12.202 31.8639L32.3176 0.222435C32.3754 0.111218 32.5488 0 32.7222 0H56.017C56.2482 0 56.4216 0.111218 56.4795 0.278044C56.5373 0.444871 56.5373 0.667306 56.4216 0.834132L32.78 26.4142H40.7569C40.9881 26.4142 41.1615 26.5254 41.2193 26.7478C41.2771 26.9147 41.2193 27.1371 41.1037 27.3039C29.6008 37.536 7.69333 57.1103 6.99968 57.7776C6.94188 57.9444 6.76847 58 6.59506 58Z"
            fill="url(#paint24_linear_644_1963)"
        />
        <path
            d="M40.7569 26.9147H31.6239L56.017 0.500488H32.7222L12.6644 32.0863H22.7222L6.65283 57.4439C6.82624 57.1103 40.7569 26.9147 40.7569 26.9147Z"
            fill="url(#paint25_linear_644_1963)"
        />
        <path
            d="M32.7222 0.500488L24.5719 13.3461L36.2482 21.9099L56.017 0.500488H32.7222Z"
            fill="url(#paint26_linear_644_1963)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_644_1963"
                x1="70.3215"
                y1="-14.4065"
                x2="56.1905"
                y2="35.8584"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F3A200" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_644_1963"
                x1="70.3215"
                y1="-14.4065"
                x2="56.1905"
                y2="35.8584"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F3A200" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_644_1963"
                x1="70.3215"
                y1="-14.4063"
                x2="56.1905"
                y2="35.8585"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F3A200" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_644_1963"
                x1="70.3215"
                y1="-14.4065"
                x2="56.1905"
                y2="35.8584"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F3A200" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_644_1963"
                x1="64.6458"
                y1="3.25656"
                x2="55.2474"
                y2="39.1102"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F9F7CF" />
                <stop offset="1" stopColor="#F6D500" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_644_1963"
                x1="64.6458"
                y1="3.25651"
                x2="55.2474"
                y2="39.1102"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F9F7CF" />
                <stop offset="1" stopColor="#F6D500" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_644_1963"
                x1="64.6458"
                y1="3.25661"
                x2="55.2473"
                y2="39.1103"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F9F7CF" />
                <stop offset="1" stopColor="#F6D500" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_644_1963"
                x1="64.6458"
                y1="3.25656"
                x2="55.2474"
                y2="39.1102"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F9F7CF" />
                <stop offset="1" stopColor="#F6D500" />
            </linearGradient>
            <linearGradient
                id="paint8_linear_644_1963"
                x1="66.2417"
                y1="-2.43972"
                x2="51.9133"
                y2="50.366"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F7B600" />
            </linearGradient>
            <linearGradient
                id="paint9_linear_644_1963"
                x1="66.2417"
                y1="-2.43972"
                x2="51.9133"
                y2="50.366"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F7B600" />
            </linearGradient>
            <linearGradient
                id="paint10_linear_644_1963"
                x1="66.2417"
                y1="-2.43951"
                x2="51.9133"
                y2="50.3662"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F7B600" />
            </linearGradient>
            <linearGradient
                id="paint11_linear_644_1963"
                x1="66.2418"
                y1="-2.43972"
                x2="51.9134"
                y2="50.366"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F7B600" />
            </linearGradient>
            <linearGradient
                id="paint12_linear_644_1963"
                x1="91.1239"
                y1="24.5041"
                x2="82.7664"
                y2="54.2321"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#DDDDDD" />
                <stop offset="1" stopColor="#CBCBCB" />
            </linearGradient>
            <linearGradient
                id="paint13_linear_644_1963"
                x1="91.1239"
                y1="24.5043"
                x2="82.7664"
                y2="54.2323"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#DDDDDD" />
                <stop offset="1" stopColor="#CBCBCB" />
            </linearGradient>
            <linearGradient
                id="paint14_linear_644_1963"
                x1="91.1238"
                y1="24.5039"
                x2="82.7664"
                y2="54.2319"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#DDDDDD" />
                <stop offset="1" stopColor="#CBCBCB" />
            </linearGradient>
            <linearGradient
                id="paint15_linear_644_1963"
                x1="91.1239"
                y1="24.5038"
                x2="82.7664"
                y2="54.2319"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#DDDDDD" />
                <stop offset="1" stopColor="#CBCBCB" />
            </linearGradient>
            <linearGradient
                id="paint16_linear_644_1963"
                x1="87.668"
                y1="34.9624"
                x2="82.0911"
                y2="56.2373"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#EEEEEE" />
            </linearGradient>
            <linearGradient
                id="paint17_linear_644_1963"
                x1="87.6677"
                y1="34.9626"
                x2="82.0908"
                y2="56.2375"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#EEEEEE" />
            </linearGradient>
            <linearGradient
                id="paint18_linear_644_1963"
                x1="87.6677"
                y1="34.9626"
                x2="82.0908"
                y2="56.2375"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#EEEEEE" />
            </linearGradient>
            <linearGradient
                id="paint19_linear_644_1963"
                x1="87.6678"
                y1="34.9626"
                x2="82.0909"
                y2="56.2375"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#EEEEEE" />
            </linearGradient>
            <linearGradient
                id="paint20_linear_644_1963"
                x1="88.5742"
                y1="31.6466"
                x2="80.0916"
                y2="62.9083"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#EEEEEE" />
                <stop offset="1" stopColor="#DDDDDD" />
            </linearGradient>
            <linearGradient
                id="paint21_linear_644_1963"
                x1="88.5743"
                y1="31.6464"
                x2="80.0917"
                y2="62.9081"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#EEEEEE" />
                <stop offset="1" stopColor="#DDDDDD" />
            </linearGradient>
            <linearGradient
                id="paint22_linear_644_1963"
                x1="88.5743"
                y1="31.6464"
                x2="80.0916"
                y2="62.9081"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#EEEEEE" />
                <stop offset="1" stopColor="#DDDDDD" />
            </linearGradient>
            <linearGradient
                id="paint23_linear_644_1963"
                x1="88.5742"
                y1="31.6464"
                x2="80.0916"
                y2="62.9081"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#EEEEEE" />
                <stop offset="1" stopColor="#DDDDDD" />
            </linearGradient>
            <linearGradient
                id="paint24_linear_644_1963"
                x1="43.1813"
                y1="-8.98739"
                x2="21.9616"
                y2="56.6713"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F6D500" />
                <stop offset="1" stopColor="#F3A200" />
            </linearGradient>
            <linearGradient
                id="paint25_linear_644_1963"
                x1="42.9933"
                y1="-8.44819"
                x2="22.0864"
                y2="56.2424"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F5E500" />
                <stop offset="1" stopColor="#F7B600" />
            </linearGradient>
            <linearGradient
                id="paint26_linear_644_1963"
                x1="26.1972"
                y1="17.8012"
                x2="63.3057"
                y2="-14.0806"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#F5E500" />
                <stop offset="1" stopColor="#F7B600" />
            </linearGradient>
        </defs>
    </svg>
);
